function env(name: string): string | undefined {
  const value = process.env[name];
  return value && value.trim() !== "" ? value : undefined;
}

export const URLS = {
  privacyPolicy:
    env("REACT_APP_PRIVACY_POLICY_URL") ??
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/villkor-och-regler/villkor-nar-du-reser-med-oss/hantering-av-personuppgifter",

  mainWebsite: env("REACT_APP_MAIN_WEB_URL") ?? "https://ostgotatrafiken.se",

  companyPortal:
    env("REACT_APP_COMPANY_PORTAL_URL") ??
    "https://foretag.ostgotatrafiken.se/",
};
